import { render, staticRenderFns } from "./AboutWrittenResponseOrder.vue?vue&type=template&id=978dae2c&scoped=true"
import script from "./AboutWrittenResponseOrder.vue?vue&type=script&lang=ts"
export * from "./AboutWrittenResponseOrder.vue?vue&type=script&lang=ts"
import style0 from "./AboutWrittenResponseOrder.vue?vue&type=style&index=0&id=978dae2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978dae2c",
  null
  
)

export default component.exports